import { z } from "zod";

export const ClientSchema = z.object({
  clientId: z.string(),
  clientSecret: z.string(),
  name: z.string(),
  createdAt: z.iso.datetime({ offset: true }),
});

export const InvitationSchema = z.object({
  organizationId: z.string(),
  organizationName: z.string(),
  recipientEmail: z.string(),
  senderName: z.string(),
  invitationTime: z.string(),
});

export const OrganizationSchema = z.object({
  id: z.string(),
  name: z.string(),
  edgeDevices: z.array(z.string()),
  activeLicenses: z.array(z.string()),
  fiscalYearStartMonth: z.int().min(2).max(12).optional(),
});
